import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from './Useletter';
import Foter from './Foter';
function Makup() {
  return (
    <div>
       <Container>
      <Row>
        <Col >
          <video 
        src="https://www.junaidjamshed.com/media/weltpixel/owlcarouselslider/videos/cosmetic_video_web.mp4" 
        autoplay 
        muted 
        controls 
        loop 
        width="100%" 
        height="auto">
        Your browser does not support the video tag.
    </video>
        </Col>
       
      </Row>
      </Container>
    
    <Container>
      <Row>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/face_section.jpeg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/lips_section.png'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>
     

      <Container>
      <Row >
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/eyes_section_1.png'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/makup_section.png'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px'
        }}/>
        </Col>
      </Row>
      </Container>
 <Useletter/>
 <Foter/>
    </div>
  )
}

export default Makup
